import { BaseRecipesClient, Recipe } from "@core/types";
import { SupaRecipe } from "../types/supabaseFragments";
import { converterSupaRecipeToRecipe } from "./converters";

class RecipesClient extends BaseRecipesClient {
  async getRecipes(): Promise<Recipe[]> {
    const response = await this.instance.get<SupaRecipe[]>("/wp-json/wc/v3/recipes");

    return response.data.map(converterSupaRecipeToRecipe);
  }

  async getRecipeById(recipeId: Recipe["id"]): Promise<Recipe | null> {
    const response = await this.instance.get<SupaRecipe>("/wp-json/wc/v3/recipes", {
      params: { recipeId },
    });

    return response.data ? converterSupaRecipeToRecipe(response.data) : null;
  }
}

export default RecipesClient;
